import { areDevTogglesEnabled } from 'constants/config';

export const MSW_MOCKS_STORAGE_KEY = 'ENV0_MSW_MOCKS';
export const MSW_MOCKS_MODE_STORAGE_KEY = 'ENV0_MSW_MOCKS_MODE';

export const MOCK_MODES = {
  'with-data': 'With data',
  'zero-states': 'Zero states'
} as const;

export type MockMode = keyof typeof MOCK_MODES;

export const areMocksEnabled = (): boolean =>
  areDevTogglesEnabled && localStorage.getItem(MSW_MOCKS_STORAGE_KEY) === 'true';

export const getMockMode = (): MockMode =>
  localStorage.getItem(MSW_MOCKS_MODE_STORAGE_KEY) === 'zero-states' ? 'zero-states' : 'with-data';

export const isZeroStatesMode = (): boolean => getMockMode() === 'zero-states';

export const startMocks = async (): Promise<void> => {
  if (!areMocksEnabled()) return;

  const [{ setupWorker }, { handlers }] = await Promise.all([import('msw/browser'), import('./handlers')]);

  await setupWorker(...handlers).start({ onUnhandledRequest: 'bypass', quiet: true });
};
